import { APP_VERSION } from "../appVersion";

export interface WithdrawalCompletionTelemetry {
  id: string;
  started_at: string;
  finished_at: string;
  status: "ok" | "error";
  app_version: string;
  mode: "create" | "finalize_draft" | "edit";
  client_uuid: string | null;
  withdrawal_number: number | null;
  prewarm_cache_hit: boolean;
  timings_ms: {
    total: number;
    prewarm_wait: number;
    document_total: number;
    canonical_pdf: number;
    pdfjs_flatten_render: number;
    flattened_pdf_encode: number;
    webp_encode: number;
    server_number_lookup?: number;
    indexeddb_write?: number;
    recovery_snapshot?: number;
  };
  blob_bytes: {
    total: number;
    pdf: number;
    webp: number;
    label: number;
    source: number;
    detection_source: number;
    analysis_input: number;
    rectification_input: number;
    ocr_warp: number;
    vision_feedback: number;
    live_training: number;
  };
  error?: string;
}

const STORAGE_KEY = "materialentnahme:completion-timing-diagnostics:v1";
const UPDATED_EVENT = "materialentnahme:completion-timing-diagnostics-updated";
const MAX_ENTRIES = 30;

function readRaw(): WithdrawalCompletionTelemetry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed as WithdrawalCompletionTelemetry[] : [];
  } catch {
    return [];
  }
}

function writeRaw(entries: WithdrawalCompletionTelemetry[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
    window.dispatchEvent(new Event(UPDATED_EVENT));
  } catch {
    // Timing-Telemetrie ist reine Diagnose und darf den Abschluss niemals blockieren.
  }
}

export function createWithdrawalCompletionTelemetryBase(
  mode: WithdrawalCompletionTelemetry["mode"],
  startedAtIso: string,
): Omit<WithdrawalCompletionTelemetry, "finished_at" | "status" | "prewarm_cache_hit" | "timings_ms" | "blob_bytes"> {
  return {
    id: crypto.randomUUID(),
    started_at: startedAtIso,
    app_version: APP_VERSION,
    mode,
    client_uuid: null,
    withdrawal_number: null,
  };
}

export function saveWithdrawalCompletionTelemetry(entry: WithdrawalCompletionTelemetry): void {
  const entries = readRaw();
  entries.unshift(entry);
  writeRaw(entries);
  console.info("[Materialentnahme][Step4-Abschluss]", entry);
}

export function getWithdrawalCompletionTelemetry(): WithdrawalCompletionTelemetry[] {
  return readRaw();
}

export function clearWithdrawalCompletionTelemetry(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(UPDATED_EVENT));
  } catch {
    // Best effort.
  }
}

export function withdrawalCompletionTelemetryUpdatedEvent(): string {
  return UPDATED_EVENT;
}
